import idb from "@/plugins/indexdb.js";
import CorsetRepo from "@/repositories/products/corsetRepository";

import corsetDefaultForm from "./forms/corset";

export default {
  namespaced: true,

  state: {
    corset: corsetDefaultForm
  },

  mutations: {
    SET_CORSET(state, payload) {
      state.corset = Object.assign({}, state.corset, payload);
    },

    // Reset corset object
    RESET_CORSET(state) {
      state.corset = corsetDefaultForm;
    }
  },
  actions: {
    /**
     * Get corset product by uuid
     *
     * @param {String} corset_uuid Corset uuid
     */
    async get({ commit }, corset_uuid) {
      try {
        const { data } = await CorsetRepo.get(corset_uuid);
        commit("SET_CORSET", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new corset
    async createCorset(context, payload) {
      try {
        const { data } = await CorsetRepo.createCorset(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Local part
     */

    /**
     * Get corset product from IndexedDB
     *
     * @param {String} corset_uuid Corset uuid
     */
    async getFromLocal({ commit }, corset_uuid) {
      const corset = await idb.db.corset.get(corset_uuid);

      // If not found return null
      if (!corset) return null;

      commit("SET_CORSET", corset);

      return corset;
    },

    // Reset corset
    resetProduct({ commit }) {
      commit("RESET_CORSET");
    }
  }
};
